<template>
	<div>
		<div class="row">
			<div class="col-sm-2">
				<b>Status</b>
				<select v-model="status" class="form-control">
					<option value="all">Todos</option>
					<option value="0">Novos</option>
					<option value="1">Iniciados</option>
					<option value="2">Finalizados</option>
					<option value="3">Atrasados</option>
					<option value="4">Atraso de Início</option>
					<option value="5">Atraso de Finalização</option>
				</select>
			</div>

			<div class="col-sm-3">
				<b>Contrato / Cód interno</b>
				<input v-model="cod" type="text" class="form-control" />
			</div>

			<div class="col-sm-5">
				<b>Serviço / Tarefa</b>
				<input v-model="serv_tar" type="text" class="form-control" />
			</div>

			<div class="col-sm-2">
				<b>Depto</b>
				<select v-model="depto" class="form-control">
					<option value="">TODOS</option>
					<option
						v-for="(depto, index) in assets.deptos"
						:key="index"
						:value="depto.cod"
					>
						{{ depto.titulo }}
					</option>
				</select>
			</div>

			<div class="col-sm-4">
				<b>Cliente</b>
				<input v-model="cliente" type="text" class="form-control" />
			</div>

			<div class="col-sm-4" @click="testFilter()">
				<b>Regiões</b>
				<DropDraw
					:asset="regionsSelect"
					title="regiao"
					v-model="regions"
				/>
			</div>

			<div class="col-sm-4">
				<b>Intervalo</b>
				<div class="input-group">
					<span class="input-group-addon">
						<i class="fa fa-calendar"></i>
					</span>
					<div class="form-control" id="datepicker-trigger">
						{{ fDate(dateOne) }} - {{ fDate(dateTwo) }}
					</div>
				</div>
				<div class="cnt-airbnb">
					<div class="airbnb">
						<AirbnbStyleDatepicker
							id="wrapper-date"
							trigger-element-id="datepicker-trigger"
							:mode="'range'"
							:months-to-show="2"
							:date-one="dateOne"
							:date-two="dateTwo"
							:fullscreen-mobile="true"
							@date-one-selected="
								(val) => {
									dateOne = val;
								}
							"
							@date-two-selected="
								(val) => {
									dateTwo = val;
								}
							"
						/>
					</div>
				</div>
			</div>
		</div>
		<!-- <pre>{{assets.deptos}}</pre> -->
	</div>
</template>
<script>
	import fDate from 'js/date';
	import { mapState } from 'vuex';
	import WBS from 'js/http';

	import DropDraw from 'app/drop-draw';

	export default {
		inject: ['assets'],
		components: { DropDraw },
		data() {
			let iniData = new Date();
			iniData.setMonth(iniData.getMonth() - 1);

			let hoje = new Date();
			hoje.setDate(hoje.getDate() + 15);
			return {
				cod: '',
				status: 'all',
				serv_tar: '',
				cliente: '',
				dateOne: iniData,
				dateTwo: hoje,
				depto: '',
				regionsSelect: '',
				regions: '',
			};
		},
		watch: {
			// whenever regions changes, this function will run
			regions(updatedRegions, oldRegions) {
				let search = [];

				if (updatedRegions != '') {
					const regionsSelected2 = this.regionsSelect
						.filter((region) => {
							if (!updatedRegions.includes(region.cod)) return;
							return region.regiao;
						})
						.map((region) => region.regiao);

					const query = ` regiao in ('${regionsSelected2.join(
						"', '"
					)}') `;

					const regionQuery = {
						find: 'razao_social',
						out: 'cliente',
						table: 'clientes',
						where: query,
					};

					search.push(regionQuery);
				}

				if (this.depto != '') search.push(`depto = '${this.depto}'`);

				search.push(
					` ( dInicio > '${this.fDate(
						this.dateOne,
						'YY-MM-DD'
					)}' and dInicio < '${this.fDate(
						this.dateTwo,
						'YY-MM-DD'
					)}' ) `
				);

				// if(this.status != 'all')

				if (this.status == '3') {
					let atraso = [];
					// Atraso para iniciar ........
					atraso.push(
						" datediff(dInicio, case when dComeco is null or dComeco = '0000-00-00 00:00:00' then now() else dComeco end) < 0 "
					);

					// Atraso para finalizar .........
					atraso.push(
						" datediff(from_unixtime( UNIX_TIMESTAMP(dInicio) + duracao*60 ), case when dTermino is null or dTermino = '0000-00-00 00:00:00' then now() else dTermino end) < 0 "
					);

					search.push(' ( ' + atraso.join(' or ') + ' ) ');
				} else if (this.status == '4') {
					let atraso = [];

					// Atraso para iniciar ........
					atraso.push(
						" datediff(dInicio, case when dComeco is null or dComeco = '0000-00-00 00:00:00' then now() else dComeco end) < 0 "
					);

					search.push(' ( ' + atraso.join(' or ') + ' ) ');
				} else if (this.status == '5') {
					let atraso = [];

					// Atraso para finalizar .........
					atraso.push(
						" datediff(from_unixtime( UNIX_TIMESTAMP(dInicio) + duracao*60 ), case when dTermino is null or dTermino = '0000-00-00 00:00:00' then now() else dTermino end) < 0 "
					);

					search.push(' ( ' + atraso.join(' or ') + ' ) ');
				} else if (this.status != 'all') {
					search.push(`status = ${this.status}`);
				}

				if (this.cod != '') {
					search.push({
						find: 'cod',
						out: 'contrato',
						table: 'contrato',
						where: ` cod_interno like '%${this.cod}%' or cod like '%${this.cod}%' `,
					});
				}

				if (this.serv_tar != '')
					search.push(
						`( servico like '%${this.serv_tar}%' or tarefa like '%${this.serv_tar}%' )`
					);

				if (this.cliente != '')
					search.push(
						`( cnpj like '%${this.cliente}%' or cliente like '%${this.cliente}%' )`
					);

				//console.log(search)
				this.$emit('updateTab', search);
			},
		},

		methods: {
			testFilter() {},

			handleLoadRegion() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-regions', testParms, (resp) => {
					const unorderedRegions = resp.data.table;
					this.regionsSelect = unorderedRegions.sort((a, b) =>
						a.regiao.localeCompare(b.regiao)
					); //order the object alphabetically
				});
			},

			fDate(data, mask = 'DD xmxs') {
				let date = new Date(data);
				date.setDate(date.getDate() + 1);
				return fDate(date, mask);
			},
			update() {
				let search = [];

				if (this.depto != '') search.push(`depto = '${this.depto}'`);

				search.push(
					` ( dInicio > '${this.fDate(
						this.dateOne,
						'YY-MM-DD'
					)}' and dInicio < '${this.fDate(
						this.dateTwo,
						'YY-MM-DD'
					)}' ) `
				);

				// if(this.status != 'all')

				if (this.status == '3') {
					let atraso = [];
					// Atraso para iniciar ........
					atraso.push(
						" datediff(dInicio, case when dComeco is null or dComeco = '0000-00-00 00:00:00' then now() else dComeco end) < 0 "
					);

					// Atraso para finalizar .........
					atraso.push(
						" datediff(from_unixtime( UNIX_TIMESTAMP(dInicio) + duracao*60 ), case when dTermino is null or dTermino = '0000-00-00 00:00:00' then now() else dTermino end) < 0 "
					);

					search.push(' ( ' + atraso.join(' or ') + ' ) ');
				} else if (this.status == '4') {
					let atraso = [];

					// Atraso para iniciar ........
					atraso.push(
						" datediff(dInicio, case when dComeco is null or dComeco = '0000-00-00 00:00:00' then now() else dComeco end) < 0 "
					);

					search.push(' ( ' + atraso.join(' or ') + ' ) ');
				} else if (this.status == '5') {
					let atraso = [];

					// Atraso para finalizar .........
					atraso.push(
						" datediff(from_unixtime( UNIX_TIMESTAMP(dInicio) + duracao*60 ), case when dTermino is null or dTermino = '0000-00-00 00:00:00' then now() else dTermino end) < 0 "
					);

					search.push(' ( ' + atraso.join(' or ') + ' ) ');
				} else if (this.status != 'all') {
					search.push(`status = ${this.status}`);
				}

				if (this.cod != '') {
					search.push({
						find: 'cod',
						out: 'contrato',
						table: 'contrato',
						where: ` cod_interno like '%${this.cod}%' or cod like '%${this.cod}%' `,
					});
				}

				if (this.serv_tar != '')
					search.push(
						`( servico like '%${this.serv_tar}%' or tarefa like '%${this.serv_tar}%' )`
					);

				if (this.cliente != '')
					search.push(
						`( cnpj like '%${this.cliente}%' or cliente like '%${this.cliente}%' )`
					);

				if (this.regions != '') {
					const regionsSelected2 = this.regionsSelect
						.filter((region) => {
							if (!this.regions.includes(region.cod)) return;
							return region.regiao;
						})
						.map((region) => region.regiao);

					const query = ` regiao in ('${regionsSelected2.join(
						"', '"
					)}') `;

					const regionQuery = {
						find: 'razao_social',
						out: 'cliente',
						table: 'clientes',
						where: query,
					};

					search.push(regionQuery);
				}
				//console.log(search)
				this.$emit('updateTab', search);
			},
		},
		mounted() {
			$('.form-control').change(this.update);
			$('.action-buttons > button:nth-child(2)').click(this.update);
			this.handleLoadRegion();
		},
	};
</script>
<style>
	.airbnb-style-datepicker-wrapper {
		position: absolute !important;
		width: 600px !important;
		z-index: 100 !important;
		top: 41px !important;
		right: 0px !important;
		left: 0px !important;
	}
	div.datepicker-inner-wrapper {
		margin: 3px 0 0 0 !important;
	}
	.airbnb {
		position: absolute;
		right: 601px;
		top: -40px;
	}
	.cnt-airbnb {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/supervisao/components/filter.vue